import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TIER_FEATURES } from '../data/onboardingData';
import './WelcomeCard.css';

/**
 * WelcomeCard — dismissible dashboard card summarising plan features.
 *
 * Props:
 *   tier      — 'pro' | 'premium'
 *   userName  — first name string
 *   onDismiss — callback fired after exit animation completes
 */
function WelcomeCard({ tier, userName, onDismiss }) {
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  if (!tier || (tier !== 'pro' && tier !== 'premium')) return null;

  const isPro = tier === 'pro';
  const features = TIER_FEATURES[tier] || [];
  const ctaPath = isPro ? '/matched-jobs' : '/cv-optimise';
  const ctaLabel = isPro ? 'Start Matching' : 'Optimise My CV';

  const handleDismiss = () => {
    setExiting(true);
    // Wait for exit animation before calling onDismiss
    setTimeout(onDismiss, 350);
  };

  return (
    <div className={`welcome-card welcome-card-${tier}${exiting ? ' welcome-card-exit' : ''}`}>
      <div className="welcome-card-header">
        <div className="welcome-card-badge">
          <i className={`fas ${isPro ? 'fa-crown' : 'fa-gem'}`}></i>
          <span>{isPro ? 'Pro' : 'Premium'} Plan Active</span>
        </div>
        <button
          className="welcome-card-dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss welcome card"
        >
          <i className="fas fa-times"></i>
        </button>
      </div>

      <p className="welcome-card-message">
        Welcome, {userName}! Here's everything included in your {isPro ? 'Pro' : 'Premium'} plan:
      </p>

      <ul className="welcome-card-features">
        {features.map((f, i) => (
          <li key={i} className="welcome-card-feature-item">
            <i className={`fas ${f.icon}`}></i>
            <span>{f.text}</span>
          </li>
        ))}
      </ul>

      <div className="welcome-card-footer">
        <button
          className="welcome-card-cta"
          onClick={() => navigate(ctaPath)}
        >
          {ctaLabel} <i className="fas fa-arrow-right"></i>
        </button>
      </div>
    </div>
  );
}

export default WelcomeCard;
